import { Box, Typography } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';
import React from 'react';

import { Neutrals } from '../../../core-components/theme/color-palette/colors';
import { fillColumnSx, PROSE_MAX } from '../../../core-components/theme/components/Screen';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export const authPanelSx: SystemStyleObject<Theme> = fillColumnSx;

export const authContentSx: SystemStyleObject<Theme> = { display: 'flex', flexDirection: 'column', gap: 6, minInlineSize: 0 };

export const authFieldsSx: SystemStyleObject<Theme> = { display: 'flex', flexDirection: 'column', gap: 4, minInlineSize: 0 };

export const authLeadSx: SystemStyleObject<Theme> = { color: Neutrals[700], maxInlineSize: PROSE_MAX };

const titleSx = (theme: Theme): SystemStyleObject<Theme> => ({
  fontSize: { xs: theme.typography.h1.fontSize, sm: theme.typography.title.fontSize },
  fontWeight: theme.typography.title.fontWeight,
  lineHeight: theme.typography.lineHeightHeading,
  color: Neutrals[900],
  textWrap: 'balance',
  overflowWrap: 'anywhere',
  '&:focus:not(:focus-visible)': { outline: 'none' },
});

const headingBlockSx: SystemStyleObject<Theme> = { display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2 };

export interface AuthPanelHeadingProps {
  readonly title: string;
  readonly titleId?: string;
  readonly titleRef?: React.Ref<HTMLHeadingElement>;
  readonly titleDescribedBy?: string;
  readonly children?: React.ReactNode;
}

export const AuthPanelHeading: React.FC<AuthPanelHeadingProps> = ({ title, titleId, titleRef, titleDescribedBy, children }) => {
  useDocumentTitle(title);
  return (
    <Box sx={headingBlockSx}>
      <Typography
        ref={titleRef}
        id={titleId}
        tabIndex={titleRef ? -1 : undefined}
        aria-describedby={titleDescribedBy}
        variant="title"
        component="h1"
        sx={titleSx}
      >
        {title}
      </Typography>
      {children}
    </Box>
  );
};

export interface AuthSubtitleProps {
  readonly id: string;
  readonly children: React.ReactNode;
}

export const AuthSubtitle: React.FC<AuthSubtitleProps> = ({ id, children }) => (
  <Typography id={id} variant="body" component="p" sx={authLeadSx}>
    {children}
  </Typography>
);
